import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { st, classes } from './NavStep.st.css';
var NavStep = /** @class */ (function (_super) {
    __extends(NavStep, _super);
    function NavStep() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavStep.prototype.render = function () {
        var _a = this.props, active = _a.active, disabled = _a.disabled, visited = _a.visited, children = _a.children, className = _a.className, rest = __rest(_a, ["active", "disabled", "visited", "children", "className"]);
        var ariaProps = {};
        active && (ariaProps['aria-current'] = 'page');
        return (React.createElement("li", __assign({}, ariaProps, rest, { className: st(classes.root, { active: active, visited: visited, disabled: disabled }, className) }), children));
    };
    return NavStep;
}(React.PureComponent));
export { NavStep };
//# sourceMappingURL=NavStep.js.map